/**
 * Utility functions and constants for dispose-related operations
 */

/**
 * Common reason options for disposing inventory items
 */
export const reasonOptions = [
    { value: '', label: 'Select Reason' },
    { value: 'quality', label: 'Quality Issue' },
    { value: 'expiration', label: 'Expiration Date' },
    { value: 'short-dated', label: 'Short-Dated' },
    { value: 'damaged', label: 'Damaged' },
    { value: 'recall', label: 'Recall' },
    { value: 'depricated', label: 'Depricated' },
    { value: 'poor-sales', label: 'Poor Sales' },
    { value: 'other', label: 'Other' }
];

/**
 * Gets a select-compatible options array with the first option being "Select Reason"
 * @returns {Array} An array of options for the select dropdown
 */
export const getReasonSelectOptions = () => {
    return reasonOptions;
};

/**
 * Find a reason option by its value
 * @param {string} value The value to search for
 * @returns {Object|undefined} The matching option or undefined if not found
 */
export const findReasonOption = (value) => {
    return reasonOptions.find(option => option.value === value);
}; 